'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../../common');

var _commonFormsy = require('../../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var AdditionalLiensModal = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(AdditionalLiensModal, _Component);

  function AdditionalLiensModal(props) {
    _classCallCheck(this, AdditionalLiensModal);

    var _this = _possibleConstructorReturn(this, (AdditionalLiensModal.__proto__ || Object.getPrototypeOf(AdditionalLiensModal)).call(this, props));

    _initDefineProp(_this, 'liens', _descriptor, _this);

    _initDefineProp(_this, 'isLoading', _descriptor2, _this);

    _this.liens = props._case.additional_liens.liens || [{ amount: '', id: _uuid2.default.v4(), note: '', type: '' }];
    return _this;
  }

  _createClass(AdditionalLiensModal, [{
    key: 'onFormChange',
    value: function onFormChange(data) {
      this.liens = Object.assign(this.liens, this.refForm.getModel()).liens;
    }
  }, {
    key: 'onValidSubmit',
    value: function onValidSubmit(data) {
      this.props.onValidSubmit(data, this.liens);
    }
  }, {
    key: 'handleAddLienClick',
    value: function handleAddLienClick() {
      var lien = { amount: '', note: '', type: '' };
      lien.id = _uuid2.default.v4();
      this.liens.push(lien);
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      return _react2.default.createElement(
        'div',
        null,
        this.liens.map(function (lien, idx) {
          return _react2.default.createElement(
            'div',
            { key: 'additional_liens-' + idx, className: 'form-group-merged' },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.Input, {
                name: 'liens[' + idx + '].id',
                type: 'hidden',
                value: lien.id
              })
            ),
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.Input, {
                name: 'liens[' + idx + '].type',
                label: 'Type',
                validations: 'isValidLienType',
                validationErrors: {
                  isValidLienType: 'Lien Type must be less that 30 characters'
                },
                value: lien.type
              })
            ),
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(
                'div',
                { className: 'field-group-icon' },
                _react2.default.createElement(_commonFormsy.Input, {
                  addonBefore: _react2.default.createElement(
                    _InputGroup2.default.Addon,
                    null,
                    '$'
                  ),
                  name: 'liens[' + idx + '].amount',
                  label: 'Amount',
                  type: 'number',
                  value: lien.amount
                })
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.Textarea, {
                className: 'additional-lien-note',
                name: 'liens[' + idx + '].note',
                label: 'Note',
                value: lien.note
              })
            )
          );
        }),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'form-group-content' },
            _react2.default.createElement(
              _Button2.default,
              { className: 'button_add_flat_fee', bsStyle: 'link', onClick: this.handleAddLienClick },
              _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
              'Add Lien'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.onClose;


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: onClose },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            onChange: this.onFormChange,
            onValidSubmit: this.onValidSubmit,
            ref: this.setRefForm
          },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              'Additional Liens'
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: this.isLoading, bsStyle: 'primary', type: 'submit' },
                'Save'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return AdditionalLiensModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object,
  additionalLiens: _propTypes2.default.array,
  CaseStore: _propTypes2.default.object,
  onClose: _propTypes2.default.func,
  onValidSubmit: _propTypes2.default.func
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'liens', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = AdditionalLiensModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(AdditionalLiensModal, 'AdditionalLiensModal', '/app/src/components/page-case/main-details/AdditionalLiensModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/AdditionalLiensModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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